export const visit = (vm, at) => {
vm(require("foundations-components/lang/en.lyaml"));
at({ "en": { "placeholder": "placeholder" } });
};